import React from "react";
import { LineItem, PaymentMethod } from "types";
import { PaymentMethodIcon } from "../../Common/PaymentMethodIcon";

export const PaymentMethodInfo = ({
    lineItem,
    isPartnerPurchase = false,
}: {
    lineItem: LineItem;
    isPartnerPurchase?: boolean;
}) => {
    const method =
        (lineItem.refundToStoreCredit || lineItem.fundingSource) && !isPartnerPurchase
            ? PaymentMethod.STORE_CREDIT
            : lineItem.payment?.method;

    return method ? <PaymentMethodIcon showTooltip method={method} /> : null;
};
